import { render } from "./ReviewsComments.vue?vue&type=template&id=9b8c38d2"
import script from "./ReviewsComments.vue?vue&type=script&lang=js"
export * from "./ReviewsComments.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__